import React from "react";
import HeaderWithSearch from "./HeaderWithSearch";
import "./BusinessCard.css";
import businessCardPhoto from "./Business-card/Untitled-design.png";

function BusinessCard() {
  return (
    <>
      <HeaderWithSearch />
      <main className="business-card-page">
        <section className="business-card-shell">
          <h1 className="business-card-title">Business Card</h1>
          <p className="business-card-subtitle">
            A classic HTML and CSS style card project.
          </p>

          <div className="business-card-layout">
            <img
              className="business-card-photo"
              src={businessCardPhoto}
              alt="Vivaan standing in front of an aquarium"
            />
            <div className="business-card-content">
              <h3>Zoey Muchetty</h3>
              <p>Smart and sleepy cat</p>
              <h4>California, USA</h4>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default BusinessCard;
